import type { ProductDetail } from "@/shared/api/inventory";

/** Shared Product glance fields — plan/40 peek + View summary. */

export function productKindLabel(kind: "stocked" | "service"): string {
  return kind === "stocked" ? "Stocked" : "Service";
}

/** Sum warehouse qty strings; blank/invalid treated as 0. */
export function productOnHandTotal(
  balances: ReadonlyArray<{ qty: string }>,
): string {
  let sum = 0;
  let any = false;
  for (const row of balances) {
    const n = Number(String(row.qty).replace(/,/g, ""));
    if (!Number.isFinite(n)) continue;
    sum += n;
    any = true;
  }
  if (!any) return "0";
  // Keep integer-looking totals clean; otherwise trim float noise.
  if (Number.isInteger(sum)) return String(sum);
  return String(Math.round(sum * 1000) / 1000);
}

export function productGlanceStats(detail: ProductDetail): {
  kindLabel: string;
  sku: string | null;
  onHand: string;
  avgCost: string | null;
  priceCount: number;
  deactivated: boolean;
} {
  const p = detail.product;
  return {
    kindLabel: productKindLabel(p.kind),
    sku: p.sku,
    onHand: p.kind === "stocked" ? productOnHandTotal(detail.balances) : "—",
    avgCost: p.avgCost,
    priceCount: detail.prices.length,
    deactivated: p.deactivatedAt != null,
  };
}
